// src/pages/dashboards/CompanyDashboard.jsx
// Company portal layout: nav + nested routes. Scoped to the linked company.
// Landing is the overview dashboard (scan pool + analytics).

import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import DashboardLayout from "../../components/DashboardLayout";
import { BarChart3, ClipboardList, UserGroup } from "../../components/icons";

import CompanyOverview from "./company/CompanyOverview";
import CompanyClaims from "./company/CompanyClaims";
import CompanyCodes from "./company/CompanyCodes";

const NAV = [
  { label: "Dashboard", path: "/company", icon: BarChart3 },
  { label: "Claims", path: "/company/claims", icon: ClipboardList },
  { label: "Team", path: "/company/codes", icon: UserGroup },
];

export default function CompanyDashboard() {
  return (
    <Routes>
      <Route element={<DashboardLayout nav={NAV} />}>
        <Route index element={<CompanyOverview />} />
        <Route path="claims" element={<CompanyClaims />} />
        <Route path="codes" element={<CompanyCodes />} />
        <Route path="*" element={<Navigate to="/company" replace />} />
      </Route>
    </Routes>
  );
}